import { ManualView } from 'components/shared/ManualView';
import { FC } from 'react';
import { load } from 'recaptcha-v3';
import { getExaminationId } from 'redux/examination/thunks';
import { useAppDispatch } from 'redux/store';
import { PretestStrings } from 'utils/strings';

interface PretestManualProps {
  routeTo: () => void;
}

export const PretestManual: FC<PretestManualProps> = ({ routeTo }) => {
  const dispatch = useAppDispatch();

  const getRecaptchaToken = async () => {
    if (process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY) {
      const recaptcha = await load(
        process.env.REACT_APP_PUBLIC_RECAPTCHA_SITE_KEY,
        {
          autoHideBadge: true,
          explicitRenderParameters: { badge: 'bottomleft', size: 'invisible' },
        }
      );
      const token = await recaptcha.execute('createExamination');

      void dispatch(getExaminationId(token));
    } else {
      void dispatch(getExaminationId());
    }

    routeTo();
  };

  return (
    <ManualView
      data={PretestStrings().Manual}
      routeTo={() => void getRecaptchaToken()}
    />
  );
};
